module.exports = __webpack_public_path__ + "img/logo-2.46e42742.png";